export default __webpack_public_path__ + "static/media/Instagram_White.b6725b52.svg";